/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */

import React from 'react';
import IndustrySectorSelector, { getDefaultIcb2019, getIndustryLevels } from '../industry-sector-selector';
import { Button, Form, FormGroup, Label } from 'reactstrap';
import { IndustryLevels } from '../../types/initiative';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducers';
import Select from 'react-select'
import { BaseStepCompProps } from './types';

const SectorInfo = (props: BaseStepCompProps) => {
  const { formData, updateForm, handleNext, handlePrevious } = props;
  const industryState = useSelector((state: RootState) => state.industrySectors.data)

  const isDisabled = !formData.industry.icb2019?.level4;

  const handleIndustrySector = (icb2019: IndustryLevels) => {
    updateForm('industry', { ...formData.industry, icb2019: icb2019 })
  }

  const handleIndustryChange = (option?: { value: string } | null) => {
    const code = option?.value ?? '';
    handleIndustrySector(getIndustryLevels(code));
  }

  const industry = getDefaultIcb2019(formData.industry?.icb2019);
  const hasIndustryLevel = !!formData.industry.icb2019?.level1;

  const industryOptions = industryState?.map(c => ({ value: c.code, label: c.name, searchString: c.name.concat(' ', c.code) }));

  const selectedIndustry = industryOptions?.find(o => o.value === industry) ?? null;


  const reactSelectStyles = {
    control: (base: any) => ({
      ...base,
      color: '#cacaca',
      backgroundColor: '#e6e8ed'
    }),
  };

  return <>
    <div className='d-lg-flex justify-content-between onboarding-form'>
      <aside className='title-container'>
        <div className='h1 mb-3'>Sector info</div>
        <p>This will help us identify which of the UN Sustainable Development
          Goals are most relevant to your industry.</p>
      </aside>
      <section className='form-container'>
        <Form className='my-5' >
          <FormGroup>
            <Label for='industrySelect'>Search and select your industry</Label>
            <Select
              id={'industrySelect'}
              name='industrySelect'
              placeholder='Enter your industry sector'
              options={industryOptions}
              value={selectedIndustry}
              onChange={handleIndustryChange}
              isClearable={true}
              styles={hasIndustryLevel && !selectedIndustry ? reactSelectStyles : {}}
            />
          </FormGroup>
          <div className='border-top mt-4 pt-3' />
          <FormGroup className={`${!selectedIndustry && !hasIndustryLevel ? 'industryDropdown' : ''}`}>
            <Label for='industrySectorSelect' className='mb-3'>Or select through dropdowns</Label>
            <IndustrySectorSelector industry={industry} handleIndustrySector={handleIndustrySector} />
          </FormGroup>
        </Form>
        <div className='mt-3 d-flex'>
          <Button outline className='mr-auto' onClick={handlePrevious}><i className='far fa-angle-left mr-2' />Back</Button>
          <Button data-testid={'sgx-sector-info-next-btn'} disabled={isDisabled} color='primary' className='ml-1' onClick={handleNext}>Next<i className='far fa-angle-right ml-2' /></Button>
        </div>
      </section>
    </div>
  </>
}

export default SectorInfo;
